import React from "react";
import { Link } from "react-router-dom";

import Page from "../../../../components/Page";
import OrderableQuestionnaires from "../../components/OrderableQuestionnaires";
import { translations } from "../../../../config";

/**
 * Komponente um statische Inhalte auszugeben
 */
class SafetyApps extends React.Component
{
	render()
	{
		const { orderableQuestionnaires } = { ...this.props };
		
		return <Page title={"Imera"} pageUrl={"/safety-apps"}>
			<div className={"col s12"}>
				
				{orderableQuestionnaires.length > 0 && <OrderableQuestionnaires questionnaires={orderableQuestionnaires} basicPriceInfo/>}
				
				<div className={"col s12 spacer"}/>
				
				<Link to={translations.de_DE.routes.registration}>
					<h3 className={"col m8 unset-padding margin-bottom"}>Eröffnen Sie jetzt Ihr Imera Kundenkonto.</h3>
					<div className={"col m4 tRight unset-padding"}><div className={"btn"}>Los geht´s!</div></div>
				</Link>
				
				<div className={"col s12 spacer"}/>
			</div>
		</Page>;
		
	} // function render()
	
} // class

export default SafetyApps;